import RequisicaoAdapter from '../adapters/RequisicaoAdapter'
import avatarUsuario from '../consts/avatarUsuario'
import endpoints from '../consts/endpoints'
import { Usuario } from '../models/Usuario'

class UsuarioService {
  static async obtemInformacoesPeloToken(
    token: string
  ): Promise<Usuario[] | undefined> {
    const url = endpoints.usuario.informacoes.viaToken

    return RequisicaoAdapter.request<Usuario[]>({
      url,
      headers: {
        client_id: `${process.env.REACT_APP_CLIENT_ID}`,
        access_token: token,
        'x-origin-channel': 'web',
        'x-origin-application': 'web'
      }
    }).then(response => {
      return response.data.map(usuario => ({
        ...usuario,
        avatar: usuario.avatar || avatarUsuario,
        dataNascimento: usuario.dataNascimento
          ? usuario.dataNascimento
              .split('/')
              .reverse()
              .join('-')
          : ''
      }))
    })
  }
}

export default UsuarioService
